namespace Areas.Reviewers {
    "use strict";


    var tabItems = Areas.createTabsWithSameController("Reviewers", ["Active", "Closed"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.vendorId; },
            "<a href= '/Vendor/ViewPrint/Index/{placeholder}' target=\"_blank\">View Profile</a>");
    }

    export function viewProfile(e: any) {
        const dataGrid: any = $("#ContractLinkListGrid").dxDataGrid("instance");
        const selectedRows: any = dataGrid.getSelectedRowsData();

        if (selectedRows.length == 1) {
            var id = selectedRows[0].vendorId;
            let linkInfo = "/Vendor/ViewPrint/Index/" + id;
            window.open(linkInfo);
        } else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }

    }

    export function listGridOnSelectionChanged(e: any) {
        let rowData: any = e.selectedRowsData[0];
        if (rowData.contractVendorId == 0) {
            enableButton("LinkButton");
        } else {
            disableButton("LinkButton")
        }
    }

    export function link() {
        const dataGrid: any = $("#ContractLinkListGrid").dxDataGrid("instance");
        const selectedRows: any = dataGrid.getSelectedRowsData();
        const dataId = selectedRows[0].vendorId;

        const parameters: any = { dataId: dataId };

        const createContractVendorLinkDialog =
            new Areas.Dialogs.CreateContractVendorLinkDialog(dialogContractVendorLinkClosing, parameters);
    }

    function dialogContractVendorLinkClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const linkInfo = "/Reviewers/ContractLink/Edit/" + data.vendorId;
        location.href = linkInfo;

    }


    export function returnVendor() {

        const dataGrid: any = $("#ContractLinkListGrid").dxDataGrid("instance");
        const selectedRows: any = dataGrid.getSelectedRowsData();
   

        if (selectedRows.length) {
            const id = selectedRows[0].vendorId;
            const url = `/Reviewers/List/ReturnVendor/${id}`;

            sendRequest(url, "", "POST", () => {
                dataGrid.refresh();
                dataGrid.selectRowsByIndexes([0]);
            });
        }
    }


}